import React, {Component} from "react";
import {connect} from "react-redux";
import {graphql} from "react-apollo";
import Table from "../../components/Table";
import DeliveryItem from "../../subscriptions/views//DeliveryItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import gql from "graphql-tag";

class SubscriptionDeliveries extends Component {

  componentDidMount() {
    if (this.props.subscriptionId) {
      this.subscribe(this.props);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.subscriptionId && (prevProps.subscriptionId !== this.props.subscriptionId)) {
      this.subscribe(this.props);
    }
  }

  subscribe(props) {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToMore(props, {});
  }  

  render() {
    let {loading, error, subscriptionDeliveries} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Delivery Id",
      "Recipient",
      "Qty",
      "Destination",
      "Warehouse",
      "Prep Date",
      "Delivery",
      "Status",
      ""
    ])          
    return (
      <Table 
        data={fromJS(subscriptionDeliveries)} 
        renderer={DeliveryItem} 
        onItemClick={this.handleItemClick.bind(this)}
        onContextMenuClick={this.handleContextMenuClick.bind(this)}
        tableHeader={tableHeader}
        extraClassName="DeliveryList"
        itemKey="deliveryId"
        mode="table"
        />
    )
  }

  handleItemClick(itemData, e, field = "") {
    e.stopPropagation();
    let id = itemData.get("deliveryId");
    this.props.onSelectionChange(id);
  }  

  handleContextMenuClick(itemData, x, y) {
    // do nothing here.
  }
}


const DELIVERIES = gql`
  query subscriptionDeliveries($filter:SubscriptionDeliveryFilterInput!) {
    subscriptionDeliveries(filter: $filter) {
      deliveryId
      warehouseId
      status
      stockStatus
      scheduleStatus
      requestedDeliveryDate
      deliveryDate
      retryScheduling
      prepDate
      shippingAddress {
        name
        addressStateProvince
        addressCity
        addressCountryCode
      }
      products {
        quantity
      }
    }
  }
`

const DELIVERIES_SUBSCRIPTION = gql`
  subscription onSubscriptionDeliveriesUpdated($subscriptionId:ID!) {
    updatedSubscriptionDeliveries(subscriptionId: $subscriptionId) {
      subscriptionId
    }
  }
`


const withQuery = graphql(DELIVERIES, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        subscriptionId: props.subscriptionId
      }
    }
  })
});

const mapDispatchToProps = dispatch => ({
  subscribeToMore: (props, params) => {
    return props.data.subscribeToMore({
      document: DELIVERIES_SUBSCRIPTION,
      variables: {
        subscriptionId: props.subscriptionId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})


export default connect(null, mapDispatchToProps)(withQuery(SubscriptionDeliveries));